module.exports = __webpack_public_path__ + "static/media/타.07987274.jpg";